import { render, staticRenderFns } from "./Calendar_v2.vue?vue&type=template&id=21571adf&scoped=true&"
import script from "./Calendar_v2.vue?vue&type=script&lang=js&"
export * from "./Calendar_v2.vue?vue&type=script&lang=js&"
import style0 from "./Calendar_v2.vue?vue&type=style&index=0&id=21571adf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21571adf",
  null
  
)

export default component.exports